import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex text-gray-950 text-xs font-500 border-b" }
const _hoisted_2 = { style: {"width":"35%"} }
const _hoisted_3 = { class: "d-flex align-left item py-2" }
const _hoisted_4 = { style: {"width":"65%"} }
const _hoisted_5 = { class: "d-flex align-left item py-2" }
const _hoisted_6 = { style: {"width":"35%"} }
const _hoisted_7 = { class: "d-flex align-left item pt-1" }
const _hoisted_8 = { style: {"width":"65%"} }

import { withDefaults } from 'vue';
import * as comps from '@/components/atoms';

interface IProps {
  items: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeTooltip',
  props: {
    items: { default: [
    {
      title: 'Azul',
      color: '#801434',
      description: 'Meta em progresso'
    },
    {
      title: 'Verde',
      color: '#17cf97',
      description: 'Meta atingida e contabiliza performante'
    },
    {
      title: 'Cinza',
      color: '#8897a8',
      description: 'Meta não contabiliza performante'
    }
  ] }
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    "close-on-content-click": false,
    width: 384,
    "open-on-hover": ""
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(comps.AtomButton, _mergeProps({
        background: "dark",
        "no-hover": "",
        class: "d-flex align-center cursor-pointer pa-0"
      }, props, { style: {"width":"100%"} }), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 2
      }, 1040)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list, { style: {"border-radius":"16px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("p", _hoisted_3, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.contributor_summary.color')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('message.common.description')), 1)
                  ])
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${idx}-m`,
                  class: _normalizeClass(["d-flex text-gray-500 text-xs font-500", `${idx !== props.items.length - 1 && 'border-b'}`])
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("p", _hoisted_7, [
                      _createVNode(comps.AtomProgressBar, {
                        modelValue: 100,
                        progressColor: `${ item.color }`,
                        showPercentText: false
                      }, null, 8, ["progressColor"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", {
                      class: "d-flex align-left item pt-1 mt-3",
                      style: _normalizeStyle(`color: ${ item.color }`)
                    }, _toDisplayString(item.description), 5)
                  ])
                ], 2))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 3
  }))
}
}

})